import {parseRequest, type ParsedRequest} from './nlparse';
import type {ApiService} from '@/types/api';

/**
 * Бесплатный разбор фразы клиента на самом сайте: «хочу мойку завтра после 6».
 * Функции здесь чистые (без сети), чтобы их можно было проверить тестами.
 */

export interface LocalSlot {
  iso: string;
  dateKey: string;
  hour: number;
}

/** В автосервисе «после 6» значит вечер: малые числа читаем как вторую половину дня. */
export function normalizeHour(hour: number | null): number | null {
  if (hour === null) return null;
  return hour >= 1 && hour <= 8 ? hour + 12 : hour;
}

const STEMS: Record<string, string[]> = {
  мойка: ['мойк'],
  полировка: ['полиров'],
  'полировка фар': ['фар'],
  керамика: ['керамик'],
  химчистка: ['химчист'],
  детейлинг: ['детейл'],
};

/** Подбирает услугу по ключевому слову из фразы. Если подходит несколько — берём самую доступную по цене. */
export function pickService(services: ApiService[], keyword: string | null): ApiService | null {
  if (!keyword) return null;
  const stems = STEMS[keyword] ?? [keyword.slice(0, 5)];
  const matches = services.filter((s) => stems.some((stem) => s.name.toLowerCase().includes(stem)));
  if (matches.length === 0) return null;
  return [...matches].sort((a, b) => a.priceMinor - b.priceMinor)[0] ?? null;
}

export interface SlotQuery {
  dateKey: string | null;
  fromHour: number | null;
  toHour: number | null;
}

export function toSlotQuery(parsed: ParsedRequest, todayKey: string, tomorrowKey: string): SlotQuery {
  return {
    dateKey: parsed.day === 'today' ? todayKey : parsed.day === 'tomorrow' ? tomorrowKey : null,
    fromHour: normalizeHour(parsed.afterHour),
    toHour: normalizeHour(parsed.beforeHour),
  };
}

export function filterLocalSlots(slots: LocalSlot[], query: SlotQuery): LocalSlot[] {
  return slots.filter((slot) => {
    if (query.dateKey && slot.dateKey !== query.dateKey) return false;
    if (query.fromHour !== null && slot.hour < query.fromHour) return false;
    if (query.toHour !== null && slot.hour > query.toHour) return false;
    return true;
  });
}

/** Нужен ли локальный подбор окон: есть услуга или пожелание по дню/времени. */
export function wantsSlots(message: string): boolean {
  const parsed = parseRequest(message);
  const hasWish = parsed.day !== 'any' || parsed.afterHour !== null || parsed.beforeHour !== null;
  const asksTime = /окн|врем|запис|свобод|когда/i.test(message);
  return parsed.serviceKeyword !== null || hasWish || asksTime;
}
